import { useEffect, useState } from "react";

const useApiResult = (request): [unknown, string | null] => {
  const [results, setResults] = useState(null);
  const [error, setError] = <
    [string | null, React.Dispatch<React.SetStateAction<{}>>]
  >useState(null);

  useEffect(
    () => {
      if (!request) {
        setResults(null);
        setError(null);
        return;
      }

      const [url, options] = <[string, Record<string, string>]>request;
      fetch(url, options)
        .then(async (response) => {
          if (response.ok) {
            setResults(await response.json());
            setError(null);
          } else {
            setError(await response.text());
          }
        })
        .catch((err) => {
          setError(err.message as string);
        });
    },
    [request, setError, setResults],
  );

  return [results, error];
};

export default useApiResult;
